import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
} from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, Observable, throwError } from "rxjs";
import { ErrorNotificationService } from "./error-notification.service";
import { HANDLE_HTTP_ERROR_LOCALLY } from "./http-error-context";

/**
 * Surfaces failed HTTP responses to the user via {@link ErrorNotificationService}
 * and re-throws the error so stores/components keep their own error handling.
 *
 * Register this as the OUTERMOST interceptor (first in the {@code withInterceptors}
 * array) so that on the response path it runs last — after the mock/preview
 * fallbacks — and only notifies on genuinely failed requests.
 */
export function httpErrorInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const notifier = inject(ErrorNotificationService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (!req.context.get(HANDLE_HTTP_ERROR_LOCALLY)) {
        notifier.notifyHttpError(error);
      }
      return throwError(() => error);
    }),
  );
}
